// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class MedicalEligibilityPrescriberResult {
    static getAttributeTypeMap() {
        return MedicalEligibilityPrescriberResult.attributeTypeMap;
    }
}
MedicalEligibilityPrescriberResult.discriminator = undefined;
MedicalEligibilityPrescriberResult.additionalProperties = false;
MedicalEligibilityPrescriberResult.attributeTypeMap = [
    {
        "name": "inNetwork",
        "baseName": "inNetwork",
        "type": "string"
    },
    {
        "name": "address",
        "baseName": "address",
        "type": "MedicalEligibilityAddress"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "taxId",
        "baseName": "taxId",
        "type": "string"
    },
];
//# sourceMappingURL=medicalEligibilityPrescriberResult.js.map